module.exports = __webpack_public_path__ + "static/media/manage_accounts_blu.634de270.svg";